<template>
    <span class="number">{{ value }}</span>
</template>
<script>
import { TweenLite } from 'gsap/TweenLite'
import { Power2 } from 'gsap/EasePack'

export default
{
    name: 'logo-travelshift',

    props: {
        from: { type: Number, default: 0 },
        to: { type: Number, default: 0 },
        delay: { type: Number, default: 0 },
        duration: { type: Number, default: 3 },
        minDigits: { type: Number, default: 1 }
    },

    data()
    {
        return {
            value: this.from
        }
    },

    mounted()
    {
        this.exactValue = this.from
        TweenLite.to(
            this,
            this.duration,
            {
                exactValue: this.to,
                delay: this.delay,
                ease: Power2.easeOut,
                onUpdate: () =>
                {
                    let value = `${Math.round(this.exactValue)}`

                    if(value.length < this.minDigits)
                    {
                        value = `${Array(this.minDigits + 1 - value.length).join('0')}${value}`
                    }

                    this.value = value
                }
            }
        )
    }
}
</script>
<style lang="sass" scoped>

</style>
